import { NgModule, ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './errors-handler';
import { httpInterceptorProviders } from './interceptors';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    { provide: ErrorHandler, useClass: AppErrorHandler },
    ...httpInterceptorProviders
  ]
})
export class CoreModule {}
